import { useCallback, useLayoutEffect, useRef, useState } from 'react'

export function useNote(note: string) {
  const [isOverflowing, setIsOverflowing] = useState<boolean>(false)
  const [formattedNote, setFormatedNote] = useState<string>(note)
  const noteRef = useRef<HTMLDivElement | null>(null)
  const [expanded, setExpanded] = useState<boolean>(false)
  const [divWidth, setDivWidth] = useState<number>(0)

  const allowedLineLength = divWidth / 6.1 - 13
  const allowedDualLineLength = (divWidth * 2) / 6.1 - 13
  const allowedCharLength = (divWidth * 3) / 6.1 - 13

  useLayoutEffect(() => {
    const noteElement = noteRef.current
    const handleResize = () => {
      if (noteElement) setDivWidth(noteElement.clientWidth)
    }
    handleResize()
    window.addEventListener('resize', handleResize)

    return () => {
      window.removeEventListener('resize', handleResize)
    }
  }, [])

  const checkNoteWidth = useCallback(
    (note: string) => {
      if (note.length <= allowedLineLength) {
        return allowedLineLength
      } else if (note.length <= allowedDualLineLength) {
        return allowedDualLineLength
      } else if (note.length <= allowedCharLength) {
        return allowedCharLength
      }
      return 0
    },
    [allowedLineLength, allowedDualLineLength, allowedCharLength],
  )

  useLayoutEffect(() => {
    const noteElement = noteRef.current
    if (noteElement) {
      setIsOverflowing(noteElement?.scrollHeight > 63)
      if (noteElement) setDivWidth(noteElement.clientWidth)
    }
  }, [note])

  useLayoutEffect(() => {
    if (isOverflowing) {
      const subStrNote = note.substring(0, allowedCharLength)
      const match = /\n/.exec(subStrNote)
      if (match) {
        const splitNote = subStrNote.split(/\n/)
        let tempNote = ''
        const rounds = splitNote.length >= 3 ? 3 : splitNote.length

        for (let i = 0; i < rounds; i++) {
          const nw = i === 0 ? 0 : checkNoteWidth(tempNote)
          if (nw + splitNote[i].length < allowedCharLength) {
            if (Boolean(splitNote[i] !== ''))
              tempNote += (i > 0 ? '\r\n' : '') + splitNote[i]
          } else {
            const tempNote2 = splitNote[i].substring(
              0,
              allowedCharLength - (nw + 13),
            )
            if (Boolean(tempNote2 !== ''))
              tempNote += (i > 0 ? '\r\n' : '') + tempNote2
          }
        }

        setFormatedNote(tempNote)
      } else {
        setFormatedNote(subStrNote)
      }
    } else {
      setFormatedNote(note)
    }
  }, [divWidth, isOverflowing, note, allowedCharLength, checkNoteWidth])

  const handleToggleExpand = useCallback(() => {
    setExpanded(!expanded)
  }, [setExpanded, expanded])

  const finalNote = expanded ? note : formattedNote

  return {
    isOverflowing,
    formattedNote: finalNote,
    noteRef,
    expanded,
    handleToggleExpand,
  }
}
